// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","orderStatus":"G67da3f G9fa6b0 G81a5ae Gd6846a Gd6846a undefined Geb2b38"};